var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFurniture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.1667 25.8H1.43333C0.573333 25.8 0 26.3734 0 27.2334V78.8334V84.5667C0 85.4267 0.573333 86.0001 1.43333 86.0001H7.16667C8.02667 86.0001 8.6 85.4267 8.6 84.5667V80.2667H43V84.5667C43 85.4267 43.5733 86.0001 44.4333 86.0001H50.1667C51.0267 86.0001 51.6 85.4267 51.6 84.5667V78.8334V27.2334C51.6 26.3734 51.0267 25.8 50.1667 25.8ZM27.2333 77.4001V67.3667H48.7333V77.4001H44.4333H27.2333ZM7.16667 77.4001H2.86667V67.3667H24.3667V77.4001H7.16667ZM48.7333 51.6H2.86667V41.5667H48.7333V51.6ZM48.7333 54.4667V64.5H2.86667V54.4667H48.7333ZM48.7333 28.6667V38.7H2.86667V28.6667H48.7333ZM5.73333 83.1334H2.86667V80.2667H5.73333V83.1334ZM48.7333 83.1334H45.8667V80.2667H48.7333V83.1334Z",
    fill: "#8E7861"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5667 0H27.2334C26.3734 0 25.8 0.573333 25.8 1.43333V21.5H28.6667V2.86667H54.4667V53.0333H57.3334V2.86667H83.1334V61.6333H55.9001V64.5H83.1334V77.4H78.8334H55.9001V80.2667H77.4001V84.5667C77.4001 85.4267 77.9734 86 78.8334 86H84.5667C85.4267 86 86.0001 85.4267 86.0001 84.5667V78.8333V1.43333C86.0001 0.573333 85.4267 0 84.5667 0ZM83.1334 83.1333H80.2667V80.2667H83.1334V83.1333Z",
    fill: "#8E7861"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6332 68.8H55.8999V71.6667H61.6332V68.8Z",
    fill: "#8E7861"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 22.9333H61.6333V37.2667H64.5V22.9333Z",
    fill: "#8E7861"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4001 5.7334H31.5334V8.60006H34.4001V5.7334Z",
    fill: "#8E7861"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2666 5.7334H77.3999V8.60006H80.2666V5.7334Z",
    fill: "#8E7861"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2666 55.8999H77.3999V58.7666H80.2666V55.8999Z",
    fill: "#8E7861"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9668 71.6667H30.1001V74.5334H32.9668V71.6667Z",
    fill: "#8E7861"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 71.6667H18.6333V74.5334H21.5V71.6667Z",
    fill: "#8E7861"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1 58.7666H21.5V61.6333H30.1V58.7666Z",
    fill: "#8E7861"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1 45.8667H21.5V48.7334H30.1V45.8667Z",
    fill: "#8E7861"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1 32.9666H21.5V35.8332H30.1V32.9666Z",
    fill: "#8E7861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurniture);
export default __webpack_public_path__ + "static/media/furniture.eff71514f4884c04c707ad272dee2d20.svg";
export { ForwardRef as ReactComponent };